import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from './firebase';

export interface ClassStorePurchasePayload {
  schoolId: string;
  classId: string;
  studentId: string;
  studentName: string;
  storeItemId: string;
  itemName: string;
  price: number;
  currency: 'point' | 'stamp';
  itemType: 'point' | 'stamp';
  targetType: 'class' | 'subject';
  subjectId?: string | null;
  itemCategory?: string;
  inventoryKey: string;
  teacherId: string;
  selectedGachaItem?: Record<string, unknown> | null;
}

/** 학급 상점 구매 1건을 `classes/{classId}/purchases`에 남깁니다. 실패해도 구매 트랜잭션은 이미 반영된 상태이므로 로그만 남깁니다. */
export async function appendClassStorePurchaseLog(payload: ClassStorePurchasePayload): Promise<void> {
  const docBody: Record<string, unknown> = {
    schoolId: payload.schoolId,
    classId: payload.classId,
    studentId: payload.studentId,
    studentName: payload.studentName,
    storeItemId: payload.storeItemId,
    itemName: payload.itemName,
    price: payload.price,
    currency: payload.currency,
    itemType: payload.itemType,
    targetType: payload.targetType,
    inventoryKey: payload.inventoryKey,
    teacherId: payload.teacherId,
    createdAt: serverTimestamp(),
  };
  if (payload.subjectId) {
    docBody.subjectId = payload.subjectId;
  }
  if (payload.itemCategory) {
    docBody.itemCategory = payload.itemCategory;
  }
  if (payload.selectedGachaItem && Object.keys(payload.selectedGachaItem).length > 0) {
    docBody.selectedGachaItem = payload.selectedGachaItem;
  }
  await addDoc(collection(db, `schools/${payload.schoolId}/classes/${payload.classId}/purchases`), docBody);
}
